import { render, staticRenderFns } from "./ActiveTimeByTypeTeamComponent.vue?vue&type=template&id=1ddc797a&scoped=true&"
import script from "./ActiveTimeByTypeTeamComponent.vue?vue&type=script&lang=js&"
export * from "./ActiveTimeByTypeTeamComponent.vue?vue&type=script&lang=js&"
import style0 from "./ActiveTimeByTypeTeamComponent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ActiveTimeByTypeTeamComponent.vue?vue&type=style&index=1&id=1ddc797a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddc797a",
  null
  
)

export default component.exports